import styled from "styled-components";


export const SingleLegendWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 300px;
`

export const LabelDot = styled.div`
    width: 8px;
    height: 8px;
    background-color: ${props => props.color};
    border-radius: 50%; 
`